import React, { Component } from 'react';
import { Run, RuleRunner } from '../Validation/RuleRunner'
import { required } from '../Validation/Rules';

const fieldValidations = [
  RuleRunner("hasCheckedGeneralCondition", "La sélection des condition générales de ventes", required),
];

// When the user clicks anywhere outside of the modal, close it
/*window.onclick = function(event) {
  if (event.target == modal) {
      modal.style.display = "none";
  }
}*/

export default class GeneralCondition extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hasCheckedGeneralCondition: props.isChecked,
      modalIsOpen: false,
      validationErrors: {},
    };

    this.handleChange = this.handleChange.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    this.modal = document.getElementById("modal");

    // When we click anywhere on window
    window.onclick = function(event) {
      if (event.target == this.modal) {
        this.modal.style.display = "none";
      }
    }
  }

  handleChange(event) {
    const name = event.target.name;

    // If value is equal to on thus the element is a checkbox
    // so we get the checked value
    var value = event.target.value;
    if (value === "on") {
      value = event.target.checked
    }
  
    // Update the businessHour object
    //responsibles[index][key] = value;
    this.setState({
      [name]: value
    });
  }

  getObject() {
    return this.state.hasCheckedGeneralCondition;
  }

  /**
   * @return boolean false if there are some errors
   */
  checkForm() {
    var errors = Run(this.state, fieldValidations);

    this.setState({
      validationErrors: errors
    });


    return Object.keys(errors).length === 0;
  }

  errorFor(field) {
    return this.state.validationErrors[field] || "";
  }

  openModal(e) {
    // Call this method to don't reload the entire page
    e.preventDefault();
    this.modal.style.display = "block";
  }

  closeModal() {
    this.modal.style.display = "none";
  }

  render() {
    return (
      <div className="margin-bottom-s" id={this.props.id}>
        <div>
          <label for="hasCheckedGeneralCondition">
            <input className="margin-right-s" id="hasCheckedGeneralCondition" type="checkbox" name="hasCheckedGeneralCondition" 
              onChange={this.handleChange} checked={this.state.hasCheckedGeneralCondition}
            /> 
            Je reconnais avoir pris connaissance des 
            <button className="btn-light" onClick={this.openModal}>
              conditions générales et particulières de ventes
            </button>. 
          </label>
          <div>
            <span className="form-error">{this.errorFor("hasCheckedGeneralCondition")}</span>
          </div>
        </div>
        <div id="modal" className="modal">
          <div class="modal-content">
            <div className="modal-title">
              Conditions générales de ventes
              <span class="close" onClick={this.closeModal}>&times;</span>
            </div>

            <div className="modal-text">
              <h3>CONFIDENTIALITÉ</h3>
              <p>  
                Le fichier clients constitué dans le cadre du lancement et de la gestion du programme dans une pharmacie, est
                propriété de la pharmacie et de Mes avantages PARA. Le pharmacien s’engage à recueillir le consentement du
                client sur l’acceptation par ce dernier des conditions générales de la carte. Et le gestionnaire informatique
                s’engage à assurer la confidentialité des données nominatives et personnelles dudit fichier, et à n’en faire aucun
                usage autre que celui nécessaire à l’exécution des prestations et des obligations objet du présent contrat. En
                particulier, il est précisé que le fichier ne pourra pas être vendu à des sociétés tierces sans l’accord express de la
                pharmacie.<br/>
                Mes avantages PARA, ou toute société s’y substituant dispose d’une autorisation spéciale lui permettant :
                <ol className="list-decimal">
                  <li>
                    De réaliser des études marketing et des opérations commerciales sur l’ensemble de la base de données
                    nationale, c'est-à-dire sur le panel constitué par les clients de l’ensemble des pharmacies participant au
                    programme. Ces études seront réalisées à des fins exclusivement marketing sur une période pouvant aller jusqu’à
                    trois (3) ans après l’expiration du contrat. L’objectif de ces études et de ces actions commerciales est de d’obtenir
                    des panels représentatifs pour les pharmacies participantes ou les laboratoires partenaires, et cela, en
                    conformité avec le code de la santé publique. Il est précisé que les fichiers peuvent être loués aux laboratoires
                    partenaires.
                  </li>
                  <li>
                    De réaliser des campagnes nationales (emailing, mailing, SMSing) pour augmenter l’attachement des clients
                    au programme.
                  </li>
                </ol>
                Mes avantages PARA, ses sous-traitants et les pharmacies considèreront comme strictement confidentielles, et
                s'interdisent de divulguer, toutes informations de quelque nature que ce soit, qui pourront leur être révélées à
                l'occasion de l'exécution du présent contrat. Notamment Mes avantages PARA s'engagent à conserver secrètes
                toutes les informations sur la pharmacie qui leur auront été communiquées aux fins de traitement. La pharmacie
                s’engage à conserver le secret sur toutes les applications, techniques, méthodes, savoir-faire, créations, mises
                en œuvre par Mes avantages PARA, pour l'exécution de son contrat, et dont elle sera amenée à avoir
                connaissance. Cette clause de confidentialité s'impose également aux salariés des deux parties. Elle conservera
                effet à l'expiration du contrat et pendant une durée de deux (2) ans à compter de sa date d'expiration.
              </p>
              <h3>DURÉE D’ENGAGEMENT</h3>
              <p>
                
                L’engagement de la pharmacie au programme de fidélisation, aux conditions du présent dossier d’adhésion, est
                conclu pour une durée minimum d’un an. La pharmacie ou Mes avantages PARA peut demander la résiliation du
                contrat d’adhésion en respectant un préavis de trois (3) mois. La demande doit être adressée à la société Mes
                avantages PARA, par courrier recommandé avec accusé de réception, le cachet de la Poste faisant foi en ce qui
                concerne le début de la période de préavis. A l’expiration du préavis, la pharmacie pourra obtenir sur simple
                demande auprès de Mes avantages PARA le fichier des clients fidélisés gérés pour son compte. Le fichier sera
                restitué sur un support CD-Rom, sous la forme de fichiers textes exploitables par la pharmacie. Ce fichier devra
                comporter les coordonnées de chaque client détenteur d’une carte de fidélité et le nombre de points acquis à la
                date d’expiration de l’adhésion. La restitution du fichier sur CD-Rom et les frais de fermeture de compte seront
                facturés par Mes avantages PARA à la pharmacie, 200 € HT.
              </p>

              <p>
                Les conditions générales de vente de la société MES AVANTAGES PARA s’appliquent à toutes les prestations
                réalisées et matériel vendu par la société MES AVANTAGES PARA. Toute commande passée auprès de la société
                MES AVANTAGES PARA implique donc l’adhésion sans réserve du client aux présentes conditions générales de
                vente.
              </p>

              <h3>1. Commande</h3>
              <p>
                
                La commande n’est prise en charge qu’à compter du retour du
                bon de commande et des conditions générales de vente à la
                société MES AVANTAGES PARA, signés et datés par le client.<br/>
                La proposition commerciale formulée dans le bon de commande
                sera valable 30 jours calendaires maximum, à compter de son
                émission par la société MES AVANTAGES PARA.
              </p>

              <h3>2. Annulation</h3>
              <p>
                Aucune annulation de commande ne sera prise en compte après
                retour du bon de commande signé.<br/>
                Toute prestation et/ou matériel ayant fait l’objet d’un bon de
                commande retourné signé à la société MES AVANTAGES PARA
                sera dû dans son intégralité.
              </p>

              <h3>3. Collaboration des parties</h3>
              <p>
                La société MES AVANTAGES PARA et le client reconnaissent
                l’importance de leur collaboration effective afin de mener à bien
                le projet objet de la commande. Ils s’engagent à faire leurs
                meilleurs efforts pour faciliter l’échange d’informations
                nécessaires à sa réalisation.<br/>
                Le client fournira au personnel de la société MES AVANTAGES
                PARA tous les documents, renseignements, éléments existants
                nécessaires à la bonne compréhension du problème posé ainsi
                que tous les documents, renseignements, éléments existants
                nécessaires à la réalisation de la prestation objet de la
                commande et/ou à la vente de matériel.<br/>
                Pour ce faire, le client désignera un interlocuteur compétent qui
                le représentera auprès de la société MES AVANTAGES PARA.
                En cas de retard de fourniture ou de non fourniture des
                éléments de la part du client, la société MES AVANTAGES PARA
                procèdera à des rappels, si besoin est par lettre recommandée
                avec accusé de réception.<br/>
                Suite à ces rappels restés infructueux, le prix de la prestation
                sera exigible à la date de clôture du dossier prévue au bon de
                commande.
              </p>
            
              <h3>4. Prix</h3>
              <p>
                Les prix des prestations réalisées et/ou du matériel vendu sont
                ceux en vigueur au jour de la prise de commande.
                Ils sont libellés en euros et calculés hors taxes.
                La société MES AVANTAGES PARA s’engage à facturer le matériel
                et/ou les prestations commandés aux prix indiqués lors de
                l’enregistrement de la commande.<br/>
                Toutefois, elle s’accorde le droit de modifier ses tarifs à tout
                moment et en informera le client dans les meilleurs délais.
                Tout frais bancaire inhérent au paiement des prestations et/ou
                du matériel par le client sera à la charge exclusive de celui-ci.
              </p>
              
              <h3>5. Escompte</h3>
              <p>
                Aucun escompte ne sera consenti en cas de paiement anticipé.
              </p>

              <h3>6. Modalités et délais de paiement</h3>
              <p>
                Le règlement des commandes s’effectue par prélèvement. Pour
                certains cas, il pourra s’effectuer :
                <ul className="list-disk">
                  <li>Soit par chèque</li>
                  <li>Soit par virement</li>
                  <li>Soit par lettre de change acceptée ou non acceptée</li>
                </ul>
                Les modalités de paiement que devra respecter le client sont
                celles prévues sur le bon de commande.
              </p>
              
              <h3>7. Retard de paiement</h3>
              <p>
                Conformément à l’article L 441-6 DU Code de Commerce, des
                pénalités de retard seront dues à défaut de règlement le jour
                suivant la date de paiement qui figure sur la facture. En cas de
                non-respect des conditions prévues au bon de commande et en
                particulier, en cas de retard de paiement, le client devra verser à
                la société MES AVANTAGES PARA une pénalité de retard égale à
                3 fois le taux d’intérêt légal ainsi qu’une indemnité forfaitaire
                pour frais de recouvrement de 40 euros. Le taux d’intérêt retenu
                est celui en vigueur au jour de la réalisation de la prestation.<br/>
                Cette pénalité est calculée sur le montant hors taxes de la somme
                restant due, et court à compter de la date d’exigibilité du prix
                sans qu’aucune mise en demeure préalable ne soit nécessaire.
                La pénalité de retard se cumulera avec les intérêts légaux qui
                commenceront à courir à compter de la mise en demeure de
                payer adressée au client avec accusé de réception.
              </p>
              
              <h3>8. Clause résolutoire</h3>
              <p>
                8 jours calendaires après l’envoi au client d’une lettre de mise en
                demeure recommandée avec accusé de réception restée en tout
                ou en partie sans effet pendant ce délai, et ce en cas
                d’inexécution d’une quelconque des clauses et conditions des
                présentes conditions générales de vente qui sont toutes de
                rigueur.<br/>
                En conséquent, MES AVANTAGES PARA procèdera si bon lui
                semble à la suspension et/ou à l’interruption de ses prestations
                dans le même délai Cette disposition ne dispense pas le client du
                paiement de l’intégralité des sommes restant dues tant pour les
                prestations que pour les ventes de matériel.
              </p>
              
              <h3>9. Clause de réserve de propriété</h3>
              <p>
                La société MES AVANTAGES PARA conserve la propriété des
                biens vendus et/ou prestations réalisées jusqu’au paiement
                intégral du prix, en principal et en accessoires.
                La société MES AVANTAGES PARA se réserve le droit, dans les 8
                jours suivant la mise en demeure prévue à l’article 7, de
                revendiquer le matériel vendu et/ou le support des prestations
                réalisées et demeurées impayées.<br/>
                Cette revendication, sans préjudice des règles spécifiques aux
                cas de redressement et liquidation judiciaire, s’effectuera par
                lettre recommandée avec accusé de réception, et au cas où le
                client ne défèrerait pas à la demande, les marchandises et
                supports de prestations pourront être obtenus au besoin par
                simple ordonnance de référé.<br/>
                Dans ce cas, les acomptes versés resteront acquis à MES
                AVANTAGES PARA à titre de compensation de la jouissance de
                la marchandise et/ou prestation.
              </p>
              
              <h3>10. Livraison</h3>
              <p>
                  Concernant la vente de matériel, la livraison est effectuée :
                  <ul className="list-disk">
                    <li>soit par remise directe de la marchandise au client</li>
                    <li>soit par l’envoi d’un avis de mise à disposition au client</li>
                    <li>soit au lieu indiqué par le client sur le bon de commande</li>
                  </ul>
                  Le délai de livraison indiqué lors de l’enregistrement de la
                  commande n’est donné qu’à titre indicatif et n’est aucunement
                  garanti.<br/>
                  Par voie de conséquence, tout retard raisonnable dans la
                  livraison des produits ne pourra pas donner lieu au profit du
                  client à :
                  <ul className="list-disk">
                    <li>l’allocation de dommages et intérêts</li>
                    <li>l’annulation de la commande</li>
                  </ul>
                  Le risque de transport est supporté en totalité par le client.
                  En cas de matériel manquant ou détérioré lors du transport, le
                  client devra formuler toutes les réserves nécessaires sur le bon
                  de commande à réception dudit matériel. Ces réserves devront
                  être, en outre, confirmées par écrit dans les 5 jours suivant la
                  livraison, par courrier avec accusé de réception.
              </p>
              
              <h3>11. Publicité</h3>
              <p>
                La société MES AVANTAGES PARA est autorisée à divulguer le
                nom de son client en tant que référence commerciale.
              </p>
              
              <h3>12. Confidentialité</h3>
              <p>
                Chacune des parties s’engage à ne pas divulguer les documents
                ou renseignements de toute nature sur l’autre partie ou toute
                information dont elle aurait eu connaissance.
              </p>
              
              <h3>13. Responsabilité</h3>
              <p>
                La responsabilité de la société MES AVANTAGES PARA ne pourra
                pas être mise en œuvre si la non-exécution ou le retard dans
                l’exécution de l’une de ses obligations décrites dans les présentes
                conditions générales de vente découle d’un cas de force
                majeure.<br/>
                A ce titre, la force majeure s’entend de tout événement
                extérieur, imprévisible et irrésistible au sens de l’article 1148 du
                Code Civil.<br/>
                Le client ne pourra en aucun cas rechercher la responsabilité de
                la société MES AVANTAGES PARA si la société éditrice du logiciel
                de gestion de son officine interrompt la compatibilité de ce
                logiciel avec le module informatique MES AVANTAGES PARA. Si
                une telle interruption devait intervenir, les parties s’engagent à
                se rapprocher afin de tenter de définir ensemble les conditions
                de la poursuite de leur relation sous une autre forme. En cas
                d’échec de ce rapprochement, il sera mis fin à l’adhésion du
                client au programme MES AVANTAGES PARA sans indemnité de
                part, ni d’autre. Le fichier des clients fidélisés, gérés pour le
                compte du client, lui sera restitué sur simple demande sur un
                support CD-Rom, sous la forme de fichiers textes exploitables par
                la pharmacie.
              </p>
              
              <h3>14. Tribunaux compétents et loi applicable</h3>
              <p>
                Tout litige est soumis au droit français. A défaut de résolution
                amiable, le litige sera porté devant les tribunaux de Colmar.
              </p>        
            </div>
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Forms/GeneralCondition.js